module.exports = __webpack_public_path__ + "img/illu-cut-head.28e0d560.svg";